import IconMapPin from '@/shared/icons/NewDesign/IconMapPin'
import ShellSelect from './ShellSelect'
import useShellAddressSelect from './useShellAddressSelect'
import { SelectEmpty, SelectTile } from './styled-components'

interface ShellAddressSelectProps {
  addressesList: string[]
  selectedValue?: string | null
  selectedLabel?: string | null
  onSelect: (id: string) => void
  disabled: boolean
  missing: boolean
}

const ShellAddressSelect = ({
  addressesList,
  selectedValue,
  selectedLabel,
  onSelect,
  disabled,
  missing,
}: ShellAddressSelectProps) => {
  const { t, pinIcon, isEmpty, options } = useShellAddressSelect(addressesList)

  if (isEmpty) {
    return (
      <SelectEmpty>
        <SelectTile $onTint={false}>
          <IconMapPin size={20} />
        </SelectTile>
        {t('common:no_addresses_available')}
      </SelectEmpty>
    )
  }

  return (
    <ShellSelect
      label={t('subscriptionForm:address_module.selector_title')}
      required
      placeholder={t('common:choose')}
      icon={pinIcon}
      options={options}
      selectedId={selectedValue}
      onSelect={onSelect}
      disabled={disabled}
      missing={missing}
      copyValue={selectedLabel}
      width={408}
    />
  )
}

export default ShellAddressSelect
